module.exports = __webpack_public_path__ + "static/img/normal-scan-left.7062bc4f.jpg";